module.exports = __webpack_public_path__ + "static/flags/CV-f58bc00cd819d12c285c1d9f20d3cf2b.gif";